import { inject } from '@angular/core';
import { RedirectFunction, Route, Router } from '@angular/router';
import { RequestListComponent } from '@features/requests';
import { RequestsComponent } from './requests.component';
import { PermissionGuard, RestoreRequestListStateGuard } from '@core/guards';
import { OutkeepPermission } from '@outkeep/shared';

const redirectLegacyRequestList: RedirectFunction = route =>
  inject(Router).createUrlTree(['/requests', 'all'], {
    queryParams: route.queryParams,
  });

export const requestsRoutes: Route[] = [
  {
    path: '',
    component: RequestsComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'all',
      },
      // На роуте списка заявок RestoreRequestListStateGuard подставляет
      // в URL сохранённые в localStorage фильтр и лимит страницы, а
      // runGuardsAndResolvers: 'paramsOrQueryParamsChange' заставляет гарды
      // перезапускаться при смене query-параметров (например, клик по пункту
      // меню того же списка), чтобы фильтр не терялся.
      {
        path: 'all',
        component: RequestListComponent,
        canActivate: [PermissionGuard, RestoreRequestListStateGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          title: 'all',
          permission: OutkeepPermission.LogistOn,
        },
      },
      {
        path: 'my',
        redirectTo: redirectLegacyRequestList,
      },
      {
        path: 'requestsforus',
        redirectTo: redirectLegacyRequestList,
      },
      {
        path: 'myownrequests',
        redirectTo: redirectLegacyRequestList,
      },
      {
        path: 'companyrequests',
        redirectTo: redirectLegacyRequestList,
      },
      {
        path: 'subdivisionrequests',
        redirectTo: redirectLegacyRequestList,
      },
      {
        path: 'accessibleCounterpartiesRequests',
        redirectTo: redirectLegacyRequestList,
      },
      {
        path: 'counterpartiesAccessPointsRequests',
        redirectTo: redirectLegacyRequestList,
      },
      {
        path: ':requestNumber',
        canActivate: [PermissionGuard],
        data: {
          permission: OutkeepPermission.LogistViewRequest,
        },
        loadChildren: () =>
          import('./request-form/request-form.routes').then(
            ({ requestFormRoutes }) => requestFormRoutes,
          ),
      },
    ],
  },
];
